import React from 'react';
import { HardHat, Droplets, Siren, BadgePercent, Clock3, ShieldCheck, Star } from 'lucide-react';
import { Reveal } from '../common/Reveal';

const features = [
  { icon: HardHat, key: 'install', title: 'Roof Installation', text: 'Professional roof installation for long-lasting protection and durability.' },
  { icon: Droplets, key: 'leak', title: 'Roof Leak Repair', text: 'Expert leak repairs to keep your home dry and damage-free.' },
  { icon: Siren, key: 'emergency', title: 'Emergency Repair', text: '24/7 emergency repair services to handle urgent roofing issues.' },
];

const stats = [
  { icon: BadgePercent, value: '40%', label: 'Savings on installs & repairs' },
  { icon: Clock3, value: '24/7', label: 'Emergency response' },
  { icon: ShieldCheck, value: '100%', label: 'Licensed & insured' },
  { icon: Star, value: '5.0', label: 'Customer rating' },
];

export const IntroSection = ({ title = 'Phoenix Roofing & Chimney' }) => (
  <section className="py-24 bg-background" data-testid="intro-section">
    <div className="max-w-[1320px] mx-auto px-4 lg:px-8">
      <Reveal className="max-w-2xl">
        <span className="eyebrow">Roofing & Chimney Specialists</span>
        <h2 className="section-title mt-4" data-testid="intro-title">{title}</h2>
        <p className="mt-5 text-lg text-muted-foreground">
          <strong className="text-foreground font-semibold">Save Up to 40%</strong> on Professional Roof Installations and Repairs with Your Local Roofing and Chimney Repair Specialist.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
        {features.map((f, i) => (
          <Reveal key={f.key} delay={i * 0.1}>
            <div className="h-full rounded-2xl border border-border bg-card p-8 card-lift" data-testid={`feature-${f.key}`}>
              <span className="w-[52px] h-[52px] inline-flex items-center justify-center rounded-xl bg-primary/10 p-3.5">
                <f.icon className="w-6 h-6 text-primary" />
              </span>
              <h3 className="font-heading font-bold text-xl mt-5">{f.title}</h3>
              <p className="mt-2.5 text-muted-foreground">{f.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-14 rounded-2xl bg-dark text-dark-foreground grid grid-cols-2 lg:grid-cols-4 overflow-hidden">
          {stats.map((s) => (
            <div key={s.label} className="flex items-center gap-4 p-7 border-b lg:border-b-0 border-r border-dark-foreground/10 last:border-r-0">
              <s.icon className="w-7 h-7 text-[hsl(var(--primary-glow))] shrink-0" />
              <div>
                <p className="font-heading font-extrabold text-2xl leading-none">{s.value}</p>
                <p className="text-dark-foreground/65 text-[13px] mt-1.5">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
